/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InformationBarHeaderAliases {
  FETCH_PATIENT = 'fetch-patient',
  INFORMATION_BAR = 'information-bar',
  MAPPER_INFORMATION_BAR = 'mapper-information-bar',
}
export { InformationBarHeaderAliases };
